import { FormattedMessage } from "react-intl";

import { InputField } from "@ps-design-system/components/Input";
import { Text } from "@ps-design-system/components/Text";
import LockIcon from "@ps-design-system/icons/Lock/Lock16";

import { useIntl } from "react-intl-compat";

const WifiInstructionsField = () => {
  const intl = useIntl();

  return (
    <div className="tw-flex tw-flex-col tw-gap-16">
      <div className="tw-flex tw-flex-col tw-gap-8">
        <Text typeface="headline-4-b" element="h2" className="tw-m-0">
          <FormattedMessage
            id="hosting.arrival_guide.wifi_header"
            defaultMessage="What's your wifi name and password?"
          />
        </Text>
        <Text typeface="body-2" element="p" className="tw-m-0">
          <FormattedMessage
            id="hosting.arrival_guide.wifi_subheader"
            defaultMessage="Make it easy for your guests to get online by sharing your Wi-Fi information."
          />
        </Text>
      </div>

      <InputField
        fullWidth
        name="wifiInstructions"
        placeholder={intl.formatMessage({
          id: "hosting.arrival_guide.wifi_placeholder",
          defaultMessage:
            'Optional - example: Name "PeerspaceGuest" Password: "1234567"',
        })}
        testId="arrival-guide-form-wifi-input"
      />

      <Text
        typeface="body-2"
        element="p"
        className="tw-m-0 tw-text-gray-600"
        prefix={<LockIcon className="tw-flex-shrink-0" />}
      >
        <FormattedMessage
          id="hosting.arrival_guide.wifi_footer"
          defaultMessage="Don't worry, we'll only share this with guests after you have accepted their booking."
        />
      </Text>
    </div>
  );
};

export { WifiInstructionsField };
